/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScadenzaVoucherModalita } from './scadenza-voucher-modalita';
import { RevocaVoucherModalita } from './revoca-voucher-modalita';
import { ScadenzaVoucherDecorrenza } from './scadenza-voucher-decorrenza';
import { TipoConvenzione } from './tipo-convenzione';
import { TipoConfermaPratica } from './tipo-conferma-pratica';


export interface TipoPraticaPolicyForm { 
    version: number;
    voucher_presente?: boolean;
    is_domanda_cittadino_ripetibile?: boolean;
    nucleo_min?: number;
    nucleo_max?: number;
    is_codice_anpr_enabled?: boolean;
    cambio_stato_automatico_enabled?: boolean;
    is_domanda_per_cittadino_unica?: boolean;
    is_conflitto_solo_su_familiare?: boolean;
    is_email_per_cittadino_unica?: boolean;
    is_placeholder_codice_fiscale_nucleo_enabled?: boolean;
    is_privacy_enabled?: boolean;
    is_tipo_scuola_enabled?: boolean;
    is_modulo_esercenti_enabled?: boolean;
    is_domanda_per_esercente_unica?: boolean;
    is_domanda_esercente_ripetibile?: boolean;
    is_task_comunicazioni_enabled?: boolean;
    is_submit_operatore_abilitato?: boolean;
    is_submit_operatore_esercente_abilitato?: boolean;
    is_modifica_cittadino_pre_lavorazione_enabled?: boolean;
    url_sfondo_voucher?: string;
    url_convenzione_librerie?: string;
    scadenza_voucher?: string;
    percentuale_rendicontazione?: number;
    tipo_conferma_pratica?: TipoConfermaPratica;
    tipo_convenzione?: TipoConvenzione;
    scadenza_voucher_modalita?: ScadenzaVoucherModalita;
    scadenza_voucher_giorni?: number;
    scadenza_voucher_decorrenza?: ScadenzaVoucherDecorrenza;
    elenco_esercenti_cittadino_enabled?: boolean;
    revoca_voucher_modalita?: RevocaVoucherModalita;
    adesioni_esercenti_fino?: string;
    is_riservato_residenti?: boolean;
}



